export default __webpack_public_path__ + "static/media/lungs_img_0009_Smoking.ce327ef5.png";